import React, { Fragment, useState, useRef, useEffect } from "react"
import { accessRole } from "../../../../../helpers/access_role"
import apiResponse from "../../../../../services/apiResponse"
import { Link } from "react-router-dom"

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button, Input, Label,
} from "reactstrap"

import Select from "../../../../../helpers/ui/CustomSelect"

import IndexBloc from './Blocs/IndexBloc'
import TableActiveComponent from './Components/TableActiveComponent'

const IndexView = (props) => {

    let indexBloc = new IndexBloc();
    
    const [nip, setNip] = useState('')
    const [name, setName] = useState('')

    const [optionUnits, setOptionUnits] = useState([]);
    const [optionEmployeeStatuss, setOptionEmployeeStatus] = useState([]);
    const [selectedUnit, setSelectedUnit] = useState("")
    const [selectedStatus, setSelectedStatus] = useState("2920a911-9b3f-42cf-ad91-d05cb4ab057b")

    const activeRef = useRef();
    const inactiveRef = useRef();

    const reloadActiveRef = () => activeRef.current.setTokenAPI()
    const reloadInactiveRef = () => inactiveRef.current.setTokenAPI()

    let additionalFilter = {
        nip: nip,
        name: name,
        work_unit: selectedUnit || "",
        employee_status_uuid: selectedStatus || ""
    };

    useEffect(() => {
        additionalFilter = {
            nip: nip,
            name: name,
            work_unit: selectedUnit || "",
            employee_status_uuid: selectedStatus || ""
        };

        console.log('cek ', additionalFilter);
    }, [nip, name, selectedUnit, selectedStatus])

    useEffect(() => {
        indexBloc.workUnitChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response.result
                        setOptionUnits(response)
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        indexBloc.EmployeeStatusChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response.result
                        setOptionEmployeeStatus(response)
                    }
                    break
                case apiResponse.ERROR:
                  
                    break
                default:
                    break
            }
        })
        
        indexBloc.fetchWorkUnit({})
        indexBloc.fetchEmployeeStatus({})
    }, [])

    function handleButtonSearch() {
        reloadActiveRef()
    }

    function handleButtonReset() {
        setNip('');
        setName('');
        setSelectedUnit('')
        setSelectedStatus('')
        reloadActiveRef()
    }

    return (
        <Fragment>
            <Container fluid>
                <Card>
                    <CardBody>
                        <CardTitle>List Data Pegawai</CardTitle>
                        <CardSubtitle className="mb-3">
                            Daftar Seluruh Pegawai
                        </CardSubtitle>
                        <hr />

                        <Row className="mb-3">
                            <Label
                                htmlFor="fielCode"
                                className="col-md-2 col-form-label"
                            >
                            NIP
                            </Label>
                            <Col md="4">
                                <Input
                                    type="text"
                                    name="nip"
                                    value={nip}
                                    onChange={event => setNip(event.target.value)}
                                />
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <Label
                                htmlFor="fielCode"
                                className="col-md-2 col-form-label"
                            >
                            Nama
                            </Label>
                            <Col md="4">
                                <Input
                                    type="text"
                                    name="nama"
                                    value={name}
                                    onChange={event => setName(event.target.value)}
                                />
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <Label
                                htmlFor="gender"
                                className="col-md-2 col-form-label"
                            >
                            Status Pegawai
                            </Label>
                            <Col md="4">
                                <Select 
                                    options={optionEmployeeStatuss}
                                    onChange={option => setSelectedStatus(option ? option.employee_status_uuid : '')}
                                    isAvForm={false}
                                    optionLabel="employee_status_name"
                                    optionValue="employee_status_uuid" 
                                    defaultValue={selectedStatus}
                                    isClearable
                                />
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <Label
                                className="col-md-2 col-form-label"
                            >
                            Unit Kerja
                            </Label>
                            <Col md="4">
                                <Select
                                    options={optionUnits}
                                    onChange={option => setSelectedUnit(option ? option.work_unit_uuid : '')}
                                    isAvForm={false}
                                    optionLabel="work_unit_name_tabs"
                                    optionValue="work_unit_uuid"
                                    isClearable
                                />
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <Col md="2"></Col>
                            <Col md="10">
                                <Button 
                                    color="primary" 
                                    type="button"
                                    onClick={() => {
                                        handleButtonSearch()
                                    }}
                                >
                                    <i className="uil-search-alt"></i> Cari
                                </Button>
                                {' '}
                                <Button 
                                    color="warning" 
                                    type="button"
                                    onClick={() => {
                                        handleButtonReset()
                                    }}>
                                    <i className="uil-refresh"></i> Reset
                                </Button>
                            </Col>
                        </Row>

                        <hr />
                        <TableActiveComponent ref={activeRef} handleInactiveSuccess={reloadInactiveRef} additionalFilter={additionalFilter}/>
                    </CardBody>
                </Card>
            </Container>
        </Fragment>
    )

}

export default IndexView